const alertMessagesViewTemplate = `
<div class="form-alert">
    <span class="general-error-message" data-ng-class="{ 'container-with-red-background': type === 'alert' }">
        <img class="error-icon" alt="Error Icon"/>
        <span class="error-message-content" ng-transclude></span>
    </span>
</div>
`;
export default alertMessagesViewTemplate;
